const filterTrolley = () => ({
  event: 'trolley_search',
});

export default filterTrolley;
